import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import { I18nContext, useI18nProvider } from "~/i18n";
import { Layout } from "~/components/layout";
import { OriginalRouteGuard } from "~/components/original-route-guard";
import { Home } from "~/pages/home";
import { IpMain } from "~/pages/ip/ip-main";
import { GoodsDetail } from "~/pages/ip/goods-detail";

function LegacyGoodsRedirect() {
  return <Navigate to=".." relative="path" replace />;
}

export function App() {
  const i18n = useI18nProvider();

  return (
    <I18nContext value={i18n}>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path=":slug" element={<OriginalRouteGuard />}>
              <Route index element={<IpMain />} />
              <Route path="news/:id" element={<IpMain />} />
              <Route path="goods" element={<GoodsDetail />} />
              <Route path="goods/:id" element={<LegacyGoodsRedirect />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </I18nContext>
  );
}
